import {
  boolean,
  labeled,
  arrayRequired,
  enumRequired,
  numberRequired,
  stringRequired,
  stringOptional,
  timeStampEpochRequired
} from '../../util/joi';
import { schema as contactCompanyIndividualSchema } from './ContactCompanyIndividual.schema';
import { contactCompanyTypes } from './ContactCompanyType.enum';
import { contactCompanyTrustStructures } from './ContactCompanyTrustStructure.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      name: stringRequired(Joi, 1, 64).label(labeled(label, 'Name')),
      refNumber: stringRequired(Joi, 1, 64).label(labeled(label, 'Entity/Business number')),
      tradingName: stringOptional(Joi, 1, 64).label(labeled(label, 'Trading name')),
      dateOfRegistration: timeStampEpochRequired(Joi).label(
        labeled(label, 'Date of registration')
      ),
      stateOfRegistration: stringRequired(Joi, 1, 64).label(
        labeled(label, 'State of registration')
      ),
      numberOfEmployees: numberRequired(Joi).label(labeled(label, 'Number of employees')),
      incorporated: timeStampEpochRequired(Joi).label(labeled(label, 'Incorporated date')),
      isVatRegistered: boolean(Joi).label(labeled(label, 'GST registered')),
      isActingOnBehalfTrust: boolean(Joi).label(labeled(label, 'Acting on behalf of Trust')),
      typeOfBusinessEntity: enumRequired(
        Joi,
        contactCompanyTypes,
        labeled(label, 'Type of business entity')
      )
    })
    .when('.isActingOnBehalfTrust', {
      is: true,
      then: Joi.object().keys({
        trustStructure: enumRequired(
          Joi,
          contactCompanyTrustStructures,
          labeled(label, 'Trust structure')
        ),
        trustName: stringRequired(Joi, 1, 64).label(labeled(label, 'Trust name')),
        trustRefNumber: stringRequired(Joi, 1, 64).label(
          labeled(label, 'Trust reference number')
        )
      })
    })
    .when('.isVatRegistered', {
      is: true,
      then: Joi.object().keys({
        vatRegisteredDate: timeStampEpochRequired(Joi).label(
          labeled(label, 'GST registration date')
        )
      })
    })
    .when('.typeOfBusinessEntity.name', {
      switch: [
        {
          is: Joi.valid('sole_proprietor', 'individual_trustee'),
          then: Joi.object().keys({
            individuals: arrayRequired(
              Joi,
              Joi.object()
                .keys({
                  title: Joi.any(),
                  firstName: stringRequired(Joi, 1, 64).label(labeled(label, 'First name')),
                  familyName: stringRequired(Joi, 1, 64).label(labeled(label, 'Family name'))
                })
                .label(labeled(label, 'Individuals'))
            ).label(labeled(label, 'Individuals'))
          }),
          otherwise: Joi.object().keys({
            individuals: arrayRequired(
              Joi,
              contactCompanyIndividualSchema(Joi, labeled(label, 'Individuals'))
            ).label(labeled(label, 'Individuals'))
          })
        }
      ]
    });

export default {
  schema
};
